var _path, _g, _path2, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgIcSorry(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 120,
    height: 120,
    viewBox: "0 0 120 120",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_3_9272",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 120,
    height: 120
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M60 120C93.1371 120 120 93.1371 120 60C120 26.8629 93.1371 0 60 0C26.8629 0 0 26.8629 0 60C0 93.1371 26.8629 120 60 120Z",
    fill: "#F5AF3D"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_3_9272)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M60.0326 20.9814C59.6088 20.412 59.0562 19.951 58.4201 19.6361C57.784 19.3213 57.0823 19.1614 56.3726 19.1698H56.245C55.2745 19.1943 54.3301 19.4889 53.5177 20.0204C53.6236 20.5411 53.6669 21.0727 53.6467 21.6037C53.5463 24.5373 52.438 27.3467 50.5084 29.5587C50.1786 34.0732 49.8885 38.5905 49.638 43.11L45.421 63.1393C43.3599 72.0398 40.2882 84.0673 38.3944 89.5247L48.0831 113.071C50.5694 112.361 53.0214 111.537 55.4314 110.6C57.8411 109.663 59.698 106.915 60.6988 102.43V22.1253C60.5274 21.7167 60.3035 21.3321 60.0326 20.9814Z",
    fill: "url(#paint0_linear_3_9272)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M53.5178 20.0232C52.8062 20.4911 52.2079 21.1118 51.7666 21.8401C51.3252 22.5683 51.0517 23.3859 50.9662 24.2332C50.8146 25.6791 50.6572 27.5544 50.5056 29.5616C52.4351 27.3496 53.5435 24.5402 53.6439 21.6065C53.6651 21.0756 53.6227 20.5441 53.5178 20.0232Z",
    fill: "#FFEBDB"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M51.4482 121.647L48.6515 114.517L38.3973 89.5276L10.6015 99.3892C10.415 99.4506 10.251 99.566 10.1302 99.7206C10.0093 99.8753 9.93705 100.062 9.92252 100.258V122.422C9.93136 122.551 9.98528 122.673 10.0749 122.767C10.1646 122.861 10.2842 122.92 10.4129 122.934V122.907H50.6147C50.7599 122.906 50.9028 122.87 51.0304 122.801C51.158 122.731 51.2665 122.631 51.3461 122.51C51.432 122.385 51.4861 122.241 51.5039 122.091C51.5217 121.941 51.5026 121.788 51.4482 121.647Z",
    fill: "url(#paint1_linear_3_9272)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M61.236 20.9814C61.6598 20.4121 62.2124 19.9512 62.8485 19.6363C63.4847 19.3214 64.1863 19.1616 64.896 19.1698H65.0236C65.994 19.1944 66.9384 19.489 67.7508 20.0204C67.6451 20.5411 67.6018 21.0727 67.6218 21.6037C67.7223 24.5373 68.8306 27.3467 70.7602 29.5587C71.194 35.3024 71.5767 42.1277 71.6305 43.11L75.8462 63.1393C77.9072 72.0398 80.979 84.0673 82.8742 89.5247L73.1856 113.071C70.6992 112.361 68.2471 111.537 65.8372 110.6C63.4275 109.663 61.7024 106.915 60.7016 102.43L60.5684 22.1225C60.7405 21.7148 60.9649 21.3312 61.236 20.9814Z",
    fill: "url(#paint2_linear_3_9272)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M67.7509 20.0232C68.4624 20.4911 69.0607 21.1118 69.5021 21.8401C69.9435 22.5683 70.2169 23.3859 70.3024 24.2332C70.4541 25.6791 70.6114 27.5544 70.7631 29.5616C68.8336 27.3495 67.7253 24.5401 67.6247 21.6065C67.6038 21.0756 67.6461 20.5441 67.7509 20.0232Z",
    fill: "#FFEBDB"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M69.8148 121.647L72.6115 114.517L82.8657 89.5276L110.608 99.3892C110.788 99.4534 110.944 99.5709 111.056 99.7261C111.167 99.8813 111.229 100.067 111.233 100.258V122.422H111.346C111.346 122.665 110.99 122.934 110.748 122.934V122.907H70.6554C70.5102 122.906 70.3673 122.87 70.2397 122.801C70.1121 122.731 70.0036 122.631 69.924 122.51C69.837 122.386 69.7815 122.242 69.7625 122.092C69.7435 121.941 69.7614 121.789 69.8148 121.647Z",
    fill: "url(#paint3_linear_3_9272)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M60.7016 22.1253C60.6607 22.0297 60.6172 21.9352 60.5712 21.8419V101.089L60.7016 22.1253Z",
    fill: "#F9BD87"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M60.6591 101.087L60.5712 21.8404C60.4213 21.5348 60.2408 21.2451 60.0325 20.9758C59.5019 20.2726 58.78 19.7372 57.9531 19.4335C60.2011 49.1326 60.2011 78.9591 57.9531 108.658C59.3209 106.814 60.259 104.687 60.6988 102.434L60.6591 101.087Z",
    fill: "#DBB061"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M63.2773 19.4335C62.4505 19.7374 61.7286 20.2728 61.1978 20.9758C60.9894 21.245 60.8089 21.5347 60.6592 21.8404C60.6137 21.934 60.5702 22.0285 60.5287 22.124L60.6592 101.079V102.425C61.0601 104.668 61.9528 106.793 63.273 108.65C61.0267 78.9533 61.0281 49.1297 63.2773 19.4335Z",
    fill: "#DBB061"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M87.7561 95.8652C87.7558 95.4268 87.6256 94.9983 87.3818 94.6339C87.138 94.2695 86.7917 93.9855 86.3866 93.8179C85.9814 93.6503 85.5357 93.6067 85.1058 93.6924C84.6758 93.7781 84.2809 93.9893 83.971 94.2994C83.6611 94.6095 83.4501 95.0046 83.3647 95.4346C83.2793 95.8646 83.3232 96.3103 83.4911 96.7153C83.6589 97.1203 83.9431 97.4665 84.3076 97.71C84.6722 97.9535 85.1008 98.0835 85.5392 98.0835C86.1273 98.0831 86.6911 97.8493 87.1069 97.4333C87.5226 97.0173 87.7561 96.4533 87.7561 95.8652Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M37.6786 95.8652C37.6783 95.4268 37.5481 94.9983 37.3043 94.6339C37.0605 94.2695 36.7142 93.9855 36.3091 93.8179C35.904 93.6503 35.4582 93.6067 35.0283 93.6924C34.5983 93.7781 34.2034 93.9893 33.8935 94.2994C33.5836 94.6095 33.3726 95.0046 33.2872 95.4346C33.2017 95.8646 33.2457 96.3103 33.4136 96.7153C33.5814 97.1203 33.8656 97.4665 34.2301 97.71C34.5947 97.9535 35.0232 98.0835 35.4616 98.0835C35.7529 98.0835 36.0413 98.0261 36.3104 97.9146C36.5794 97.8031 36.8239 97.6397 37.0298 97.4337C37.2357 97.2276 37.399 96.9831 37.5103 96.714C37.6216 96.4449 37.6788 96.1564 37.6786 95.8652Z",
    fill: "white"
  }))), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.15,
    d: "M60 120C93.1371 120 120 93.1371 120 60C120 26.8629 93.1371 0 60 0C26.8629 0 0 26.8629 0 60C0 93.1371 26.8629 120 60 120Z",
    fill: "#F5AF3D"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_3_9272",
    x1: 49.5466,
    y1: 19.1695,
    x2: 49.5466,
    y2: 113.071,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FAD58D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F5AF3D"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_3_9272",
    x1: 30.7164,
    y1: 89.5276,
    x2: 30.7164,
    y2: 122.934,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#7AB4E5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#336D9D"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_3_9272",
    x1: 71.7213,
    y1: 19.1695,
    x2: 71.7213,
    y2: 113.071,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FAD58D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F5AF3D"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_3_9272",
    x1: 90.5507,
    y1: 89.5276,
    x2: 90.5507,
    y2: 122.934,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#7AB4E5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#336D9D"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcSorry);
export default __webpack_public_path__ + "static/media/ic-sorry.21b950a24c7a7c197321ea918cde04f2.svg";
export { ForwardRef as ReactComponent };